<template>
  <section class="bind-success">
    <div class="apply-content page-content">
      <header>
        <p>请用微信搜索“ETC助手”小程序</p>
        <p>查看更多详情</p>
      </header>
      <div class="qr-code">
        <img src="../../assets/apply/bind-success-code.jpg" alt="">
      </div>
      <img src="../../assets/apply/apply-success-bg.png" alt="" class="bg">
    </div>
    <div class="apply-bottom">
      <div class="tip">可通过保存二维码到相册，使用微信扫描此二维码进入“ETC”助手小程序</div>
      <button class="copy-btn" @click="save">保存二维码</button>
    </div>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// api
// config
// import ETC from '@/config/etc.config'

export default {
  name: 'bindSuccess',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
    }
  },
  computed: {},
  methods: {
    async save() {
      await this.m_clickDebounce('save')
      window.open('https://wecos.etczs.net/H5/bind-success-code-20201230.jpg')
    }
  },
  mounted() {
  },
  created() {},
  beforeDestroy() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.bind-success{
  text-align: center;
  @include routeViewMinH(284px);
  header{
    padding-top: 100px;
    font-weight: bold;
    p{
      font-size: 38px;
      color: #333333;
    }
  }
  .qr-code{
    margin: 90px auto 0;
    width: 400px;
    height: 400px;
    text-align: center;
    border-radius: 50%;
    z-index: 99;
    position: relative;
    background-color: #fff;
    img{
      margin-top: 28px;
      width: 344px;
      height: 344px;
      border-radius: 140px;
    }
  }
  .bg{
    margin-top: -130px;
    display: block;
    width: 100%;
    // height: 195px;
  }
  .apply-bottom{
    padding: 0 55px 100px;
    .tip{
      font-size: 24px;
      color: #999999;
      line-height: 34px;
    }
    button{
      margin-top: 30px;
      @extend %cool-btn;
    }
  }
}
</style>
